var _rect, _text, _text2, _circle, _circle2, _text3, _text4, _rect2, _text5, _text6, _rect3, _text7, _text8, _rect4, _text9, _text10, _rect5, _text11, _text12, _path, _polygon, _path2, _polygon2, _path3, _polygon3, _path4, _polygon4, _text13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg07ReactLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 480,
    fill: "#f8fafc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 38,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "The Agent Loop (ReAct Cycle)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 62,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Plan, Act, Observe, Reflect, then repeat until done")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 260,
    r: 145,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 2,
    strokeDasharray: "8 6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 260,
    r: 48,
    fill: "#e2e8f0",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 256,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Goal")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 276,
    textAnchor: "middle",
    fill: "#475569",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11
  }, "target")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 95,
    width: 180,
    height: 58,
    rx: 14,
    fill: "#bfdbfe",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 122,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "1. PLAN")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 140,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11
  }, "Break goal into steps")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 220,
    width: 180,
    height: 58,
    rx: 14,
    fill: "#bbf7d0",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 247,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "2. ACT")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 265,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11
  }, "Call a tool / edit code")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 365,
    width: 180,
    height: 58,
    rx: 14,
    fill: "#fef3c7",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 392,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "3. OBSERVE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 410,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11
  }, "Read tests / errors")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 220,
    width: 180,
    height: 58,
    rx: 14,
    fill: "#fce7f3",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 247,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "4. REFLECT")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 265,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11
  }, "Decide next move")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555 140 C620 150 680 185 710 220",
    stroke: "#0f172a",
    strokeWidth: 2.5,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "716,226 702,220 714,212",
    fill: "#0f172a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M710 278 C680 330 600 360 555 380",
    stroke: "#0f172a",
    strokeWidth: 2.5,
    fill: "none"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "548,382 562,376 556,390",
    fill: "#0f172a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405 380 C320 360 250 320 230 278",
    stroke: "#0f172a",
    strokeWidth: 2.5,
    fill: "none"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "226,272 238,282 220,284",
    fill: "#0f172a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230 220 C250 170 340 130 405 120",
    stroke: "#0f172a",
    strokeWidth: 2.5,
    fill: "none"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "412,119 398,126 406,112",
    fill: "#0f172a"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 460,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "A failing test is not a dead end. It is new context for the next step.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07ReactLoop);
export default __webpack_public_path__ + "static/media/07-react-loop.ae7c6ecf3aaeb35f09591a0bb86799c3.svg";
export { ForwardRef as ReactComponent };